import { ref } from 'vue';
import { Api } from '@/api/index';

export const useSensitiveField = () => {
  const isRevealed = ref(false);

  const reveal = async (customFieldValueId?: number): Promise<string> => {
    if (!customFieldValueId) {
      isRevealed.value = true;
      return '';
    }

    const response = await Api.CustomFieldValue.decryptCustomFieldValue(customFieldValueId);
    isRevealed.value = true;
    return response.record.secure_value || '';
  };

  const hide = () => {
    isRevealed.value = false;
  };

  const reset = () => {
    isRevealed.value = false;
  };

  return {
    isRevealed,
    reveal,
    hide,
    reset,
  };
};
